import { FC } from 'react';
import ProSkeleton, { SkeletonProps } from './skeleton';
import ProSkeletonButton, { SkeletonButtonProps } from './button';
import ProSkeletonAvatar, { AvatarProps } from './avatar';
import ProSkeletonInput, { SkeletonInputProps } from './input';
import ProSkeletonImage, { SkeletonImageProps } from './image';

export type ISkeletonComponent = FC<SkeletonProps> & {
  Button: FC<SkeletonButtonProps>;
  Avatar: FC<AvatarProps>;
  Input: FC<SkeletonInputProps>;
  Image: FC<SkeletonImageProps>;
};

const TransSkeleton = ProSkeleton as ISkeletonComponent;
TransSkeleton.Button = ProSkeletonButton;
TransSkeleton.Avatar = ProSkeletonAvatar;
TransSkeleton.Input = ProSkeletonInput;
TransSkeleton.Image = ProSkeletonImage;

export default TransSkeleton;
